module.exports = __webpack_public_path__ + "media/images/credits_panama_logo-499e040d6f5caaa9238381567b4f0062.jpg";